import React from 'react'
import Show from '../show'

function BudgetOverTimeDashboard() {
  return (
    <Show
      title="Budget Over Time"
      dashboardKey="bot_dashboards"
      sectionAbbreviation="BOT"
      showAnalytics={false}
    />
  )
}

export default BudgetOverTimeDashboard
